import {
  SUBSCRIBE_NEWSLETTER,
  SUBSCRIBE_NEWSLETTER_FULFILLED,
  SUBSCRIBE_NEWSLETTER_REJECTED,
} from 'b2b-apps/shop/newsletter/redux/actionTypes';
import {
  NewsletterType,
  SubscribeNewsletterAction,
  SubscribeNewsletterFulfilledAction,
  SubscribeNewsletterRejectedAction,
} from 'b2b-apps/shop/newsletter/redux/types';
import { LANGUAGE_CODE } from 'b2b-common/core/i18n/consts';

const subscribeNewsletter = (
  email: string,
  language: LANGUAGE_CODE,
): SubscribeNewsletterAction => ({
  type: SUBSCRIBE_NEWSLETTER,
  payload: {
    email,
    language,
  },
});

const subscribeNewsletterFulfilled = (
  data: NewsletterType,
): SubscribeNewsletterFulfilledAction => ({
  type: SUBSCRIBE_NEWSLETTER_FULFILLED,
  payload: {
    data,
  },
});

const subscribeNewsletterRejected = (
  error: ErrorType,
): SubscribeNewsletterRejectedAction => ({
  type: SUBSCRIBE_NEWSLETTER_REJECTED,
  payload: {
    error,
  },
});

export {
  subscribeNewsletter,
  subscribeNewsletterFulfilled,
  subscribeNewsletterRejected,
};
